/* Haye Nii: Judge.me reviews on the product page (task 17).
   Judge.me shows 5 reviews at a time. We load all of the product's reviews (20 per request, photo reviews
   first) and show them in one swipe row: 5-star reviews first, then 4, 3, 2, 1; within the same stars reviews with a
   photo first, then newest first. All cards are the
   same height; in a text card the words sit in a soft panel where the photo would be. Arrows on computers; on phones
   the row slides a little once when it comes into view, to show it can be swiped.
   "Customers mention" counts real words in this product's reviews (e.g. "gift" -> Gift-worthy (12));
   tapping one shows only the reviews that mention it.
   Tapping a star bar (e.g. 4 stars) shows only those reviews. Nothing is hidden: the row adds more cards as it is
   swiped, and the last card says all reviews were shown. No "Verified buyer" labels on any card (owner 2026-10-14:
   same look for every review).
   Tapping a card (photo, or "Read more" on long text) opens the review in a viewer on the page: big photo(s), the
   whole text, next/previous (arrows, swipe, keyboard), close with X, Esc or a tap outside. Photos never open
   Judge.me's raw image link.
   Same real reviews, same text, same Judge.me disclosure line. If anything fails, Judge.me's own list stays. */
(function () {
  if (window.hnReviewsLoaded) return; // the homepage section and the product page may both load this file
  window.hnReviewsLoaded = true;
  var PAGE_SIZE = 20; // Judge.me returns about 20 reviews per request
  var MAX_PAGES = 50; // stop at 1000 reviews
  var CHUNK = 20; // cards added to the row at a time

  // Positive themes only, matched in review title + text of 4- and 5-star reviews (a 1-star "bought it as a gift,
  // it broke" is not a gift-worthy vote). A theme shows when 2+ reviews mention it. `says` = how the written
  // summary describes it ("37 reviews ..."); it names the words we count, so the sentence is exactly true.
  var THEMES = [
    { label: 'Looks beautiful', says: 'use words like beautiful or pretty', re: /beautiful|pretty|gorgeous|stunning|lovely|elegant|cute|sundar/i },
    { label: 'Quality', says: 'mention the quality', re: /quality|well made|sturdy|solid|premium|finish/i },
    { label: 'Gift-worthy', says: 'mention a gift', re: /gift|present|birthday|anniversary|surprise/i },
    { label: 'Just as pictured', says: 'say it looks as pictured', re: /exact(ly)? (as|like|what)|as (shown|pictured|described)|same as (the )?(picture|photo|pic)|just like (the )?(picture|photo|pic)/i },
    { label: 'Photo clarity', says: 'say the photo is clear', re: /(very|so|super|really|nice|perfectly) clear|clear (photo|picture|image)|(photo|picture|image) (quality|is clear|was clear)/i },
    { label: 'Packaging', says: 'mention the packaging', re: /packag|gift box|\bbox\b|wrapped/i },
    { label: 'Compliments', says: 'mention compliments', re: /compliment|everyone (loved|asked)|people ask/i },
    { label: 'Helpful service', says: 'mention the service', re: /customer service|helpful|responsive|quick reply|support/i }
  ];

  var ARROW = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Safe for text AND attributes: review names/links come from shoppers, so quotes must be escaped too.
  function esc(text) {
    return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Move the "What customers say" summary (sections/review-summary.liquid) above "Write a review".
  function placeSummary(host) {
    var summary = document.querySelector('[data-hn-review-summary]');
    var actions = host.querySelector('.jdgm-widget-actions-wrapper');
    if (!summary || !actions || summary.nextElementSibling === actions) return;
    // the text is stored per product (snippets/review-summary-text.liquid); show it once it sits in the widget
    actions.parentNode.insertBefore(summary, actions);
    summary.classList.add('hn-rsum--in-widget');
    summary.classList.remove('page-width'); // the theme forces margin-bottom:0 on .page-width
    var section = document.querySelector('.hn-rsum-section');
    if (section && !section.contains(summary)) section.style.display = 'none';
    summary.hidden = false;
  }

  function themes(reviews) {
    var good = reviews.filter(function (r) { return r.score >= 4; });
    return THEMES.map(function (theme) {
      return { label: theme.label, says: theme.says, list: good.filter(function (r) { return theme.re.test(r.text); }) };
    }).filter(function (t) { return t.list.length >= 2; })
      .sort(function (a, b) { return b.list.length - a.list.length; });
  }

  // Default order (owner 2026-10-15): 5 stars first, then 4, 3, 2, 1. Within the same stars: reviews with a photo
  // first (the approved look), then newest first.
  function order(reviews) {
    return reviews.slice().sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      if (!!b.photo !== !!a.photo) return b.photo ? 1 : -1;
      return (b.date && !isNaN(b.date) ? +b.date : 0) - (a.date && !isNaN(a.date) ? +a.date : 0);
    });
  }

  function read(rev) {
    var pics = rev.querySelectorAll('.jdgm-rev__pic-img');
    var time = rev.querySelector('.jdgm-rev__timestamp');
    var title = rev.querySelector('.jdgm-rev__title');
    var body = rev.querySelector('.jdgm-rev__body');
    var rating = rev.querySelector('.jdgm-rev__rating');
    var data = {
      id: rev.getAttribute('data-review-id') || '',
      name: ((rev.querySelector('.jdgm-rev__author') || {}).textContent || '').trim(),
      score: parseInt((rating && rating.getAttribute('data-score')) || '0', 10),
      stars: rating ? rating.outerHTML : '',
      date: time ? toDate(time.getAttribute('datetime') || time.getAttribute('data-content') || '') : null,
      title: title ? title.textContent.trim() : '',
      body: body ? body.textContent.trim() : '',
      photos: []
    };
    pics.forEach(function (img) {
      var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
      if (src) data.photos.push(src);
    });
    data.photo = data.photos.length ? size(data.photos[0], 600) : '';
    data.text = data.title + ' ' + data.body;
    return data;
  }

  // The all-reviews list gives "2026-10-11 19:27:06 UTC", which iPhone Safari can't read: make it ISO first.
  function toDate(text) {
    var iso = String(text).trim().replace(/^(\d{4}-\d\d-\d\d) (\d\d:\d\d:\d\d) UTC$/, '$1T$2Z');
    return new Date(iso);
  }

  // Judge.me photo links carry width=...; ask for the size we need.
  function size(src, width) {
    return /width=\d+/.test(src) ? src.replace(/width=\d+/, 'width=' + width) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + width;
  }

  function when(r) {
    return r.date && !isNaN(r.date) ? r.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  }

  function card(r, i) {
    var html = '<article class="hn-rev ' + (r.photo ? 'hn-rev--pic' : 'hn-rev--text') + '" role="listitem" data-i="' + i + '">';
    var words = (r.title ? '<p class="hn-rev__title">' + esc(r.title) + '</p>' : '') +
      (r.body ? '<div class="hn-rev__body">' + esc(r.body) + '</div>' : '');
    if (r.photo) {
      html += '<button type="button" class="hn-rev__pic" aria-label="Open review by ' + esc(r.name) + '">' +
        '<img src="' + esc(r.photo) + '" alt="Photo from ' + esc(r.name) + '" loading="lazy" width="600" height="600">' +
        (r.photos.length > 1 ? '<span class="hn-rev__count">1/' + r.photos.length + '</span>' : '') + '</button>';
    } else {
      html += '<div class="hn-rev__quote">' + words + '</div>';
    }
    html += '<div class="hn-rev__who"><span class="hn-rev__avatar" aria-hidden="true">' + esc(r.name.charAt(0).toUpperCase()) + '</span>';
    html += '<span><span class="hn-rev__name">' + esc(r.name) + '</span>';
    html += '</span></div>';
    html += '<div class="hn-rev__meta">' + r.stars;
    if (when(r)) html += '<time datetime="' + r.date.toISOString() + '">' + when(r) + '</time>';
    html += '</div>';
    if (r.photo) html += words;
    html += '<button type="button" class="hn-rev__more" hidden>Read more</button>';
    return html + '</article>';
  }

  // Text cards: the panel stretches to the photo cards' height; show as many lines of the review as fit in it.
  function fit(box) {
    var quotes = box.querySelectorAll('.hn-rev__quote');
    quotes.forEach(function (q) {
      var body = q.querySelector('.hn-rev__body');
      if (body) body.style.setProperty('--hn-lines', '1');
    });
    quotes.forEach(function (q) {
      var body = q.querySelector('.hn-rev__body');
      if (!body) return;
      var style = getComputedStyle(q);
      var room = q.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      var title = q.querySelector('.hn-rev__title');
      if (title) room -= title.getBoundingClientRect().height + parseFloat(getComputedStyle(title).marginBottom);
      var line = parseFloat(getComputedStyle(body).lineHeight) || 24;
      body.style.setProperty('--hn-lines', String(Math.max(2, Math.floor(room / line))));
    });
    // "Read more" only on cards whose words are cut off
    box.querySelectorAll('.hn-rev').forEach(function (c) {
      var btn = c.querySelector('.hn-rev__more');
      if (!btn) return;
      var cut = [].some.call(c.querySelectorAll('.hn-rev__body, .hn-rev__title'), function (el) {
        return el.scrollHeight > el.clientHeight + 2;
      });
      btn.hidden = !cut;
    });
  }

  // ---------- review viewer: one for the page, opened by tapping a card ----------
  var viewer;
  var CLOSE = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function buildViewer() {
    var el = document.createElement('div');
    el.className = 'hn-rv';
    el.hidden = true;
    el.innerHTML = '<div class="hn-rv__sheet" role="dialog" aria-modal="true" aria-label="Customer review">' +
      '<button type="button" class="hn-rv__close" aria-label="Close">' + CLOSE + '</button>' +
      '<div class="hn-rv__content"></div>' +
      '<div class="hn-rv__nav"><button type="button" class="hn-rv__step hn-rv__step--prev" aria-label="Previous review">' + ARROW + '</button>' +
      '<span class="hn-rv__pos"></span>' +
      '<button type="button" class="hn-rv__step hn-rv__step--next" aria-label="Next review">' + ARROW + '</button></div>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (event) {
      if (event.target === el || event.target.closest('.hn-rv__close')) return closeViewer();
      var stepBtn = event.target.closest('.hn-rv__step');
      if (stepBtn) showReview(viewer.i + (stepBtn.classList.contains('hn-rv__step--prev') ? -1 : 1));
    });
    document.addEventListener('keydown', function (event) {
      if (el.hidden) return;
      if (event.key === 'Escape') closeViewer();
      if (event.key === 'ArrowLeft') showReview(viewer.i - 1);
      if (event.key === 'ArrowRight') showReview(viewer.i + 1);
      if (event.key === 'Tab') {
        var focusable = [].filter.call(el.querySelectorAll('button, a[href]'), function (b) { return !b.disabled; });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        else if (!el.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
      }
    });
    // phone Back button closes the viewer instead of leaving the page
    // (backPending = our own history.back() after X/Esc; if the viewer was reopened meanwhile, add its step again)
    window.addEventListener('popstate', function () {
      if (viewer.backPending) {
        viewer.backPending = false;
        if (!el.hidden) pushStep();
        return;
      }
      if (!el.hidden) closeViewer(true);
    });
    // sideways swipe on the review moves to the next one; swipes inside a photo strip scroll the photos
    var x0 = null;
    var y0 = null;
    el.addEventListener('touchstart', function (event) {
      x0 = event.touches[0].clientX;
      y0 = event.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (event) {
      if (x0 === null) return;
      var dx = event.changedTouches[0].clientX - x0;
      var dy = event.changedTouches[0].clientY - y0;
      x0 = null;
      if (event.target.closest('.hn-rv__photos--many')) return;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) showReview(viewer.i + (dx < 0 ? 1 : -1));
    }, { passive: true });
    return { el: el, list: [], i: 0, back: null, pushed: false, backPending: false };
  }

  function showReview(i) {
    var list = viewer.list;
    if (i < 0 || i >= list.length) return;
    viewer.i = i;
    var r = list[i];
    var html = '';
    if (r.photos.length) {
      html += '<div class="hn-rv__photos' + (r.photos.length > 1 ? ' hn-rv__photos--many' : '') + '">';
      r.photos.forEach(function (src, n) {
        html += '<img src="' + esc(size(src, 1200)) + '" alt="Photo ' + (n + 1) + ' from ' + esc(r.name) + '">';
      });
      html += '</div>';
    }
    html += '<div class="hn-rv__text"><div class="hn-rv__meta">' + r.stars + (when(r) ? '<time>' + when(r) + '</time>' : '') + '</div>';
    if (r.title) html += '<p class="hn-rv__title">' + esc(r.title) + '</p>';
    if (r.body) html += '<p class="hn-rv__body">' + esc(r.body) + '</p>';
    html += '<p class="hn-rv__name">' + esc(r.name) + '</p>';
    html += '</div>';
    var content = viewer.el.querySelector('.hn-rv__content');
    content.innerHTML = html;
    content.scrollTop = 0;
    var pos = viewer.el.querySelector('.hn-rv__pos');
    // homepage reviews: the bottom bar (always in view) holds "Shop the <product>" instead of "3 / 30"
    if (r.productUrl) pos.innerHTML = '<a class="hn-rv__prod" href="' + esc(r.productUrl) + '">Shop the ' + esc(r.productName) + '</a>';
    else pos.textContent = (i + 1) + ' / ' + list.length;
    viewer.el.classList.toggle('hn-rv--shop', !!r.productUrl);
    viewer.el.querySelector('.hn-rv__step--prev').disabled = i === 0;
    viewer.el.querySelector('.hn-rv__step--next').disabled = i === list.length - 1;
  }

  function openViewer(list, i, from) {
    if (!viewer) viewer = buildViewer();
    viewer.list = list;
    viewer.back = from;
    viewer.el.hidden = false;
    document.documentElement.classList.add('hn-rv-open');
    showReview(i);
    viewer.el.querySelector('.hn-rv__close').focus({ preventScroll: true });
    if (!viewer.backPending) pushStep();
  }

  function pushStep() {
    try {
      history.pushState({ hnReview: true }, '');
      viewer.pushed = true;
    } catch (e) {
      viewer.pushed = false;
    }
  }

  // fromBack = the phone/browser Back button already removed our history step
  function closeViewer(fromBack) {
    if (viewer.el.hidden) return;
    viewer.el.hidden = true;
    document.documentElement.classList.remove('hn-rv-open');
    if (viewer.back) viewer.back.focus({ preventScroll: true });
    if (viewer.pushed && !fromBack && history.state && history.state.hnReview) {
      viewer.backPending = true;
      history.back();
    }
    viewer.pushed = false;
  }

  // One row in order() (5 stars first, photo reviews first within the same stars). Starts with CHUNK cards and adds more as the row nears its end;
  // the last card says how many were shown, so shoppers can see nothing is held back.
  function render(box, reviews, empty) {
    box.hnList = order(reviews);
    box.hnShown = 0;
    if (!box.hnList.length) {
      box.innerHTML = '<p class="hn-revs__empty">' + esc(empty || 'No reviews yet.') + '</p>';
      return;
    }
    box.innerHTML = '<div class="hn-revs" role="list" aria-label="Customer reviews"></div>' +
      '<button type="button" class="hn-revs__arrow hn-revs__arrow--prev" aria-label="Previous reviews">' + ARROW + '</button>' +
      '<button type="button" class="hn-revs__arrow hn-revs__arrow--next" aria-label="Next reviews">' + ARROW + '</button>';
    var rowEl = box.querySelector('.hn-revs');
    rowEl.addEventListener('scroll', function () { more(box); arrows(box); }, { passive: true });
    more(box, true);
    rowEl.scrollLeft = 0;
  }

  // Add the next CHUNK cards when fewer than about two screens of cards are left to the right.
  function more(box, force) {
    var rowEl = box.querySelector('.hn-revs');
    var list = box.hnList;
    if (!rowEl || box.hnShown >= list.length) return;
    if (!force && rowEl.scrollLeft + rowEl.clientWidth * 3 < rowEl.scrollWidth) return;
    var html = '';
    list.slice(box.hnShown, box.hnShown + CHUNK).forEach(function (r, n) { html += card(r, box.hnShown + n); });
    box.hnShown = Math.min(list.length, box.hnShown + CHUNK);
    // end card only when the row is long enough to swipe through (1-5 reviews are all in view anyway)
    if (box.hnShown >= list.length && list.length >= 6) {
      html += '<div class="hn-rev hn-rev--end" role="listitem"><p>' +
        'That’s all ' + list.length + ' reviews' +
        '</p><button type="button" class="hn-rev__back">Back to start</button></div>';
    }
    rowEl.insertAdjacentHTML('beforeend', html);
    fit(box);
    arrows(box);
  }

  // Computer: arrows left and right of the row; each tap moves one card. Hidden at the ends.
  function arrows(box) {
    var rowEl = box.querySelector('.hn-revs');
    if (!rowEl) return;
    var end = rowEl.scrollWidth - rowEl.clientWidth - 2;
    box.querySelector('.hn-revs__arrow--prev').hidden = rowEl.scrollLeft <= 2;
    box.querySelector('.hn-revs__arrow--next').hidden = rowEl.scrollLeft >= end;
  }

  // Go to the start of the next / previous card (not "scroll by one width": with snapping that sometimes moved
  // only a few pixels, audit 2026-10-15).
  function step(box, dir) {
    var rowEl = box.querySelector('.hn-revs');
    var cards = rowEl.querySelectorAll('.hn-rev');
    if (!cards.length) return;
    var base = cards[0].offsetLeft;
    var now = rowEl.scrollLeft;
    var view = rowEl.clientWidth;
    var target = null;
    // one screen at a time: next = the first card that is not fully in view; previous = one screen back,
    // always lined up on a card's left edge
    for (var n = 0; n < cards.length; n++) {
      var left = cards[n].offsetLeft - base;
      var right = left + cards[n].offsetWidth;
      if (dir > 0 && left > now + 8 && right > now + view + 2) { target = left; break; }
      if (dir < 0 && left < now - 8 && left >= now - view - 2) { target = left; break; }
    }
    if (target === null && dir < 0) {
      for (var m = cards.length - 1; m >= 0; m--) {
        if (cards[m].offsetLeft - base < now - 8) { target = cards[m].offsetLeft - base; break; }
      }
    }
    if (target === null) target = dir > 0 ? rowEl.scrollWidth : 0;
    rowEl.scrollTo({ left: target, behavior: 'smooth' });
  }

  // Computer mouse: grab the row and drag it (hand cursor), with a short glide after letting go. Touch and pens keep
  // the browser's own swipe. A drag never opens a review; a plain click still does.
  function drag(box) {
    var rowEl = null;
    var startX = 0;
    var startLeft = 0;
    var lastX = 0;
    var lastT = 0;
    var speed = 0;
    var moved = false;
    var glide = 0;
    function stop() {
      cancelAnimationFrame(glide);
      if (rowEl) rowEl.classList.remove('hn-revs--drag');
    }
    box.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('.hn-revs__arrow, .hn-rev__back')) return;
      rowEl = event.target.closest('.hn-revs');
      if (!rowEl) return;
      cancelAnimationFrame(glide);
      startX = lastX = event.clientX;
      startLeft = rowEl.scrollLeft;
      lastT = event.timeStamp;
      speed = 0;
      moved = false;
      box.hnDragged = false;
    });
    window.addEventListener('pointermove', function (event) {
      if (!rowEl || event.pointerType !== 'mouse') return;
      if (!(event.buttons & 1)) { stop(); rowEl = null; return; } // button let go outside the window
      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        box.hnDragged = true;
        rowEl.classList.add('hn-revs--drag'); // no snapping while the hand holds the row
      }
      event.preventDefault();
      var dt = Math.max(1, event.timeStamp - lastT);
      // px per ms, capped so one jumpy mouse event can't fling the row far (glide stays under about a screen)
      speed = Math.max(-3, Math.min(3, (event.clientX - lastX) / dt));
      lastX = event.clientX;
      lastT = event.timeStamp;
      rowEl.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function (event) {
      if (!rowEl || event.pointerType !== 'mouse') return;
      var el = rowEl;
      if (!moved) { rowEl = null; return; }
      var v = event.timeStamp - lastT > 80 ? 0 : speed * 16; // px per frame
      (function frame() {
        if (Math.abs(v) < 0.5) { el.classList.remove('hn-revs--drag'); return; } // snap back on: rests on a card
        el.scrollLeft -= v;
        v *= 0.94;
        glide = requestAnimationFrame(frame);
      })();
      rowEl = null;
    });
    window.addEventListener('blur', stop);
    // the click that ends a drag must not open a review
    box.addEventListener('click', function (event) {
      if (!box.hnDragged) return;
      box.hnDragged = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    // photos: no browser "drag the image" ghost
    box.addEventListener('dragstart', function (event) { event.preventDefault(); });
  }

  // Phone: when the row first comes into view, the cards slide a little to the left and back, so people see it swipes.
  // key (homepage, task 37): only once per visit
  function hint(box, key) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try { if (key && sessionStorage.getItem(key)) return; } catch (e) { /* private mode: every visit */ }
    var seen = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      seen.disconnect();
      var rowEl = box.querySelector('.hn-revs');
      if (!rowEl || rowEl.scrollWidth <= rowEl.clientWidth || rowEl.scrollLeft > 4) return;
      try { if (key) sessionStorage.setItem(key, '1'); } catch (e) { /* private mode */ }
      setTimeout(function () { rowEl.classList.add('hn-revs--hint'); }, 400);
      rowEl.addEventListener('pointerdown', function () { rowEl.classList.remove('hn-revs--hint'); }, { once: true });
    }, { threshold: 0.6 });
    seen.observe(box);
  }

  function mentions(host, reviews, box) {
    var found = themes(reviews).slice(0, 5);
    if (!found.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'hn-mentions';
    var html = '<p class="hn-mentions__title">Customers mention</p><div class="hn-mentions__list">';
    found.forEach(function (t, i) {
      html += '<button type="button" class="hn-mentions__item" data-i="' + i + '" aria-pressed="false">' +
        esc(t.label) + ' <span class="hn-mentions__count">(' + t.list.length + ')</span></button>';
    });
    wrap.innerHTML = html + '</div>';

    wrap.addEventListener('click', function (event) {
      var btn = event.target.closest('.hn-mentions__item');
      if (!btn) return;
      var on = btn.getAttribute('aria-pressed') !== 'true';
      clearFilters(host);
      if (on) btn.setAttribute('aria-pressed', 'true');
      render(box, on ? found[+btn.dataset.i].list : reviews);
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var summary = document.querySelector('[data-hn-review-summary]');
    var actions = host.querySelector('.jdgm-widget-actions-wrapper');
    if (summary && !summary.hidden) summary.appendChild(wrap);
    else if (actions) actions.parentNode.insertBefore(wrap, actions);
  }

  function clearFilters(host) {
    host.querySelectorAll('.hn-mentions__item').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    host.querySelectorAll('.jdgm-histogram').forEach(function (h) { h.classList.remove('hn-hist--on'); });
    host.querySelectorAll('.hn-hist__row--on').forEach(function (r) { r.classList.remove('hn-hist__row--on'); });
  }

  // Star bars: Judge.me would filter its own (hidden) list, so nothing seemed to happen. We filter our row instead.
  // Tap the same bar again to see all reviews.
  function starBars(host, reviews, box) {
    function pick(event) {
      var row = event.target.closest && event.target.closest('.jdgm-histogram__row[data-rating]');
      if (!row || !host.contains(row)) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var on = !row.classList.contains('hn-hist__row--on');
      var stars = parseInt(row.getAttribute('data-rating'), 10);
      clearFilters(host);
      if (on) {
        row.classList.add('hn-hist__row--on');
        row.closest('.jdgm-histogram').classList.add('hn-hist--on');
      }
      render(box, on ? reviews.filter(function (r) { return r.score === stars; }) : reviews,
        'No ' + stars + '-star reviews yet.');
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    // capture phase, so Judge.me's own click handler never runs
    host.addEventListener('click', pick, true);
    host.addEventListener('keydown', pick, true);
  }

  function page(shop, id, n, sort) {
    var url = 'https://cdn.judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop +
      '&platform=shopify&page=' + n + '&per_page=' + PAGE_SIZE + '&product_id=' + id + '&sort_by=' + (sort || 'pictures_first');
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; });
  }

  function loadAll(host, list) {
    if (host.dataset.hnMore) return;
    host.dataset.hnMore = '1';
    var shop = (window.Shopify && window.Shopify.shop) || '';
    var id = host.dataset.productId || host.dataset.id;
    if (!shop || !id) return;

    page(shop, id, 1).then(function (first) {
      if (!first || !first.html) return;
      var pages = Math.min(Math.ceil((first.total_count || 0) / PAGE_SIZE), MAX_PAGES);
      var later = [];
      for (var n = 2; n <= pages; n++) later.push(page(shop, id, n).catch(function () { return null; }));
      return Promise.all(later).then(function (rest) {
        var seen = {};
        var reviews = [];
        [first].concat(rest).forEach(function (data) {
          if (!data || !data.html) return;
          var doc = new DOMParser().parseFromString(data.html, 'text/html');
          doc.querySelectorAll('.jdgm-rev').forEach(function (rev) {
            var r = read(rev);
            if (r.id && seen[r.id]) return;
            seen[r.id] = true;
            reviews.push(r);
          });
        });
        if (!reviews.length) return;
        var box = document.createElement('div');
        box.className = 'hn-revwrap';
        list.parentNode.insertBefore(box, list);
        host.hnBox = box;
        render(box, reviews);
        host.classList.add('hn-reviews--more');
        fit(box); // now that the row is on the page and has a size
        arrows(box);
        box.addEventListener('click', function (event) {
          var btn = event.target.closest('.hn-revs__arrow');
          if (btn) step(box, btn.classList.contains('hn-revs__arrow--prev') ? -1 : 1);
          if (event.target.closest('.hn-rev__back')) box.querySelector('.hn-revs').scrollTo({ left: 0, behavior: 'smooth' });
          var cardEl = event.target.closest('.hn-rev[data-i]');
          if (cardEl) openViewer(box.hnList, +cardEl.dataset.i, event.target.closest('button') || cardEl.querySelector('button'));
        });
        hint(box);
        drag(box);
        starBars(host, reviews, box);
        mentions(host, reviews, box);
        // measure again whenever the row changes size (fonts loading, section shown, phone turned)
        var timer;
        var refit = function () {
          clearTimeout(timer);
          timer = setTimeout(function () { fit(box); arrows(box); }, 150);
        };
        if ('ResizeObserver' in window) new ResizeObserver(refit).observe(box);
        else window.addEventListener('resize', refit);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
      });
    }).catch(function () {});
  }

  // ---------- homepage: photo reviews row (task 22, sections/hn-home-reviews.liquid) ----------
  // The cards come from snippets/home-reviews-data.liquid (built from Judge.me by
  // claude-tasks/tools/build-home-reviews.py: 4-5 stars, with a customer photo, one review per product, no repeats).
  // Nothing is fetched. A card is shown only if its product is on sale now. Tap a card = the same review viewer as the
  // product page, with a "Shop the ..." button; the small "Shop" tag under each card goes straight to the product.
  var STAR = '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L10 14.9l-5.2 2.8 1-5.9L1.5 7.7l5.9-.8z"/></svg>';

  function starRow(score) {
    var html = '';
    for (var n = 1; n <= 5; n++) html += '<span class="hn-star' + (n <= score ? ' hn-star--on' : '') + '">' + STAR + '</span>';
    return '<span class="hn-stars" role="img" aria-label="' + score + ' out of 5 stars">' + html + '</span>';
  }

  // "Feb 2026": when the review was written (task 33: real details instead of badges)
  function monthYear(d) {
    return d && !isNaN(d) ? d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '';
  }

  function homeCard(r, i) {
    var text = r.body || r.title;
    return '<article class="hn-rev hn-rev--home" role="listitem" data-i="' + i + '">' +
      '<button type="button" class="hn-rev__pic" aria-label="Open review by ' + esc(r.name) + '">' +
      '<img src="' + esc(size(r.photos[0], 600)) + '" alt="Photo from ' + esc(r.name) + ' of the ' + esc(r.productName) + '" loading="lazy" decoding="async" width="480" height="600">' +
      (r.photos.length > 1 ? '<span class="hn-rev__count">1/' + r.photos.length + '</span>' : '') + '</button>' +
      '<div class="hn-rev__home">' + r.stars +
      (text ? '<p class="hn-rev__line">' + esc(text) + '</p>' : '') +
      '<p class="hn-rev__by">' + esc(r.name) + (monthYear(r.date) ? '<time datetime="' + r.date.toISOString() + '">' + monthYear(r.date) + '</time>' : '') + '</p>' +
      prodRow(r) + '</div></article>';
  }

  // the product: small photo + name + arrow, one tap target to the product page
  function prodRow(r) {
    return '<a class="hn-rev__prod" href="' + esc(r.productUrl) + '">' +
      (r.productImage ? '<img src="' + esc(r.productImage) + '" alt="" loading="lazy" decoding="async" width="44" height="44">' : '') +
      '<span class="hn-rev__prod-name">' + esc(r.productName) + '</span>' +
      '<span class="hn-rev__prod-go" aria-hidden="true">' + ARROW + '</span></a>';
  }

  // One swipe row (arrows, mouse drag, tap = viewer) for both homepage rows
  function mountRow(section, box, list, cardFn, label) {
    if (list.length < 3) { section.hidden = true; return; } // nothing broken shows
    box.hnList = list;
    var html = '';
    list.forEach(function (r, i) { html += cardFn(r, i); });
    box.innerHTML = '<div class="hn-revs" role="list" aria-label="' + esc(label) + '">' + html + '</div>' +
      '<button type="button" class="hn-revs__arrow hn-revs__arrow--prev" aria-label="Previous">' + ARROW + '</button>' +
      '<button type="button" class="hn-revs__arrow hn-revs__arrow--next" aria-label="Next">' + ARROW + '</button>';
    var rowEl = box.querySelector('.hn-revs');
    rowEl.addEventListener('scroll', function () { arrows(box); }, { passive: true });
    box.addEventListener('click', function (event) {
      var btn = event.target.closest('.hn-revs__arrow');
      if (btn) return step(box, btn.classList.contains('hn-revs__arrow--prev') ? -1 : 1);
      if (event.target.closest('a')) return; // product row: go to the product
      var cardEl = event.target.closest('.hn-rev[data-i]');
      if (cardEl) openViewer(box.hnList, +cardEl.dataset.i, cardEl.querySelector('button'));
    });
    drag(box);
    section.classList.add('hn-hr--ready');
    arrows(box);
    hint(box, 'hn_hint_rv'); // task 37: show once per visit that the row slides sideways
    var t;
    var refit = function () { clearTimeout(t); t = setTimeout(function () { arrows(box); }, 150); };
    if ('ResizeObserver' in window) new ResizeObserver(refit).observe(box);
    else window.addEventListener('resize', refit);
  }

  function readJson(section, selector) {
    try { return JSON.parse(section.querySelector(selector).textContent); } catch (e) { return null; }
  }

  function home(section) {
    var box = section.querySelector('[data-hn-home-row]');
    var products = null;
    var data = null;
    try {
      products = JSON.parse(section.querySelector('[data-hn-home-products]').textContent);
      data = JSON.parse(section.querySelector('[data-hn-home-data]').textContent);
    } catch (e) { /* hidden below */ }
    var picked = [];
    if (box && products && Array.isArray(data)) {
      data.forEach(function (d) {
        var product = d && products[d.h];
        if (typeof product === 'string') product = { t: product }; // older list format: name only
        if (!product || !product.t || !d.p || !d.p.length || d.s < 4) return;
        picked.push({
          name: d.n || 'Customer', score: d.s, stars: starRow(d.s), date: d.d ? new Date(d.d) : null,
          title: d.t || '', body: d.b || '', photos: d.p,
          productUrl: '/products/' + d.h, productName: product.t, productImage: product.i || ''
        });
      });
    }
    if (!box) { section.hidden = true; return; }
    // task 33 (owner): a new order on every visit
    for (var i = picked.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = picked[i]; picked[i] = picked[j]; picked[j] = t;
    }
    mountRow(section, box, picked, homeCard, 'Customer photo reviews');
  }
  // For the homepage reels (assets/hayenii-reels.js): all of one product's reviews + small helpers
  function allReviews(id) {
    var shop = (window.Shopify && window.Shopify.shop) || '';
    if (!shop || !id) return Promise.resolve([]);
    return page(shop, id, 1).then(function (first) {
      if (!first || !first.html) return [];
      var pages = Math.min(Math.ceil((first.total_count || 0) / PAGE_SIZE), MAX_PAGES);
      var later = [];
      for (var n = 2; n <= pages; n++) later.push(page(shop, id, n).catch(function () { return null; }));
      return Promise.all(later).then(function (rest) {
        var seen = {};
        var out = [];
        [first].concat(rest).forEach(function (data) {
          if (!data || !data.html) return;
          new DOMParser().parseFromString(data.html, 'text/html').querySelectorAll('.jdgm-rev').forEach(function (rev) {
            var r = read(rev);
            if (r.id && seen[r.id]) return;
            seen[r.id] = true;
            out.push(r);
          });
        });
        return out;
      });
    });
  }
  // Same reviews, but in pieces: the first page as soon as it arrives (shown at once), then the other pages.
  // onBatch(reviews, total) runs once per page; resolves when every page is in.
  function streamReviews(id, onBatch) {
    var shop = (window.Shopify && window.Shopify.shop) || '';
    if (!shop || !id) { onBatch([], 0); return Promise.resolve(); }
    var seen = {};
    function take(data) {
      var out = [];
      if (!data || !data.html) return out;
      new DOMParser().parseFromString(data.html, 'text/html').querySelectorAll('.jdgm-rev').forEach(function (rev) {
        var r = read(rev);
        if (r.id && seen[r.id]) return;
        seen[r.id] = true;
        out.push(r);
      });
      return out;
    }
    return page(shop, id, 1, 'most_recent').then(function (first) { // reels reviews: newest first (owner 2026-10-20)
      var total = (first && first.total_count) || 0;
      onBatch(take(first), total);
      var pages = Math.min(Math.ceil(total / PAGE_SIZE), MAX_PAGES);
      // 2 pages at a time (not all at once): a product with 300 reviews must not take the whole phone connection
      // away from the reel video that is playing (owner 2026-10-18)
      var next = 2;
      function lane() {
        if (next > pages) return Promise.resolve();
        var n = next++;
        return page(shop, id, n, 'most_recent').then(function (d) { onBatch(take(d), total); }).catch(function () {}).then(lane);
      }
      return Promise.all([lane(), lane()]);
    });
  }
  window.hnReviews = { all: allReviews, stream: streamReviews, esc: esc, size: size, stars: starRow, when: when };

  function run() {
    var host = document.querySelector('#judgeme_product_reviews');
    if (!host) return;
    placeSummary(host);
    var list = host.querySelector('.jdgm-rev-widg__reviews');
    if (!list) return;
    if (host.hnBox && !host.contains(host.hnBox)) {
      list.parentNode.insertBefore(host.hnBox, list);
      host.classList.add('hn-reviews--more');
    }
    loadAll(host, list);
  }

  function start() {
    document.querySelectorAll('[data-hn-home-reviews]').forEach(home);
    if (!document.querySelector('#judgeme_product_reviews') && location.pathname.indexOf('/products/') < 0) return;
    run();
    // Judge.me renders after page load, so watch until the widget is there.
    var target = document.querySelector('#judgeme_product_reviews') || document.body;
    new MutationObserver(run).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
